var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from 'react';
import { throwError } from 'cerebral/internal';
import View from './View';
import * as PropTypes from 'prop-types';
var BaseComponent = /** @class */ (function (_super) {
    __extends(BaseComponent, _super);
    function BaseComponent(dependencies, props, controller, name) {
        var _this = _super.call(this, props) || this;
        if (!controller) {
            throwError('Can not find controller, did you remember to use the Container component? Read more at: http://cerebraljs.com/docs/api/components.html#react');
        }
        _this.onUpdate = _this.onUpdate.bind(_this);
        _this.view = new View({
            dependencies: dependencies,
            props: props,
            controller: controller,
            displayName: name,
            onUpdate: _this.onUpdate,
        });
        return _this;
    }
    BaseComponent.prototype.componentWillMount = function () {
        this.view.mount();
    };
    BaseComponent.prototype.shouldComponentUpdate = function () {
        return false;
    };
    BaseComponent.prototype.componentWillReceiveProps = function (nextProps) {
        var hasUpdate = this.view.onPropsUpdate(this.props, nextProps);
        if (hasUpdate) {
            this.forceUpdate();
        }
    };
    BaseComponent.prototype.componentWillUnmount = function () {
        this.view.unMount();
    };
    BaseComponent.prototype.onUpdate = function () {
        this.forceUpdate();
    };
    return BaseComponent;
}(React.Component));
export default function HOC(dependencies, Component) {
    return _a = /** @class */ (function (_super) {
            __extends(class_1, _super);
            function class_1(props, context) {
                return _super.call(this, dependencies, props, context.controller, Component.displayName || Component.name) || this;
            }
            class_1.prototype.toJSON = function () {
                return this.view._displayName;
            };
            class_1.prototype.render = function () {
                return React.createElement(Component, this.view.getProps(this.props));
            };
            return class_1;
        }(BaseComponent)),
        _a.displayName = "CerebralWrapping_" + (Component.displayName ||
            Component.name),
        _a.contextTypes = {
            controller: PropTypes.object,
        },
        _a;
    var _a;
}
//# sourceMappingURL=Hoc.js.map


//////////////////
// WEBPACK FOOTER
// /home/kryd0s/tmp/widgetbot/node_modules/@cerebral/fluent/es/Hoc.js
// module id = 151
// module chunks = 0